(function(){
'use strict';
function boot(){
 const root=document.querySelector('[data-td-favorites-page]');if(!root||root.dataset.ready)return;root.dataset.ready='1';
 const grid=root.querySelector('[data-td-favorites-grid]'),empty=root.querySelector('[data-td-favorites-empty]'),status=root.querySelector('[data-td-favorites-status]');
 // Independent fallback prevents a race between two deferred theme scripts.
 const KEY='td-favorites-v1';
 const fallback={
  read(){try{const a=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(a)?a.filter(h=>typeof h==='string'&&/^[a-z0-9-]+$/.test(h)).slice(0,60):[]}catch(e){return []}},
  remove(h){try{localStorage.setItem(KEY,JSON.stringify(this.read().filter(x=>x!==h)))}catch(e){}document.dispatchEvent(new CustomEvent('td:favorites-updated'))}
 };
 const store={read:()=>window.TDFavorites?.read?.()||fallback.read(),remove:h=>{if(window.TDFavorites?.remove)window.TDFavorites.remove(h);else fallback.remove(h)}};
 const cache=new Map(),prefix=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';let renderCount=0;
 const txt=(tag,cl,value)=>{const e=document.createElement(tag);if(cl)e.className=cl;if(value!==undefined)e.textContent=value;return e};
 const money=(amount)=>{try{return new Intl.NumberFormat('pt-PT',{style:'currency',currency:'EUR'}).format((amount||0)/100)}catch(e){return (amount/100).toFixed(2)+' €'}};
 const safeImg=(u)=>{try{const p=new URL(u,location.origin);return /^https:$/.test(p.protocol)?p.href:''}catch(e){return ''}};
 async function product(handle){
  if(cache.has(handle))return cache.get(handle);
  const res=await fetch(prefix+'products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'},credentials:'same-origin'});
  if(!res.ok)throw Error('Produto indisponível');const obj=await res.json();cache.set(handle,obj);return obj
 }
 async function draw(){
  const seq=++renderCount,handles=store.read();grid.replaceChildren();empty.hidden=!!handles.length;
  if(!handles.length){status.hidden=true;return}
  status.hidden=true;
  const results=await Promise.all(handles.map(h=>product(h).then(p=>({h,p})).catch(()=>({h,p:null}))));
  if(seq!==renderCount)return;
  results.forEach(({h,p})=>{
   const card=txt('article','td-favorite-card');
   if(!p){card.appendChild(txt('p','','Este produto já não está disponível.'));const rm=txt('button','td-favorite-card__remove','Remover');rm.onclick=()=>store.remove(h);card.appendChild(rm);grid.appendChild(card);return}
   const link=txt('a','td-favorite-card__link');link.href=prefix+'products/'+encodeURIComponent(h);
   if(p.featured_image){const img=txt('img','td-favorite-card__image');img.src=safeImg(p.featured_image);img.alt=p.title;img.loading='lazy';link.appendChild(img)}
   link.appendChild(txt('h2','',p.title));card.appendChild(link);
   const variants=(p.variants||[]).filter(v=>v.available);
   const select=txt('select','td-favorite-card__options');select.setAttribute('aria-label','Escolher tamanho e cor de '+p.title);
   variants.forEach(v=>{const option=txt('option','',v.public_title||v.title||'Único');option.value=v.id;select.appendChild(option)});
   const price=txt('p','td-favorite-card__price',variants.length?money(variants[0].price):'Esgotado');card.appendChild(price);
   if(variants.length>1)card.appendChild(select);
   if(variants.length===1)select.value=String(variants[0].id);
   if(variants.length){select.addEventListener('change',()=>{const v=variants.find(x=>String(x.id)===select.value);if(v)price.textContent=money(v.price)})}
   const add=txt('button','td-favorite-card__add',variants.length?'ADICIONAR AO CARRINHO':'ESGOTADO');add.disabled=!variants.length;
   add.addEventListener('click',async()=>{
    const v=variants.find(x=>String(x.id)===select.value)||variants[0];if(!v)return;
    add.disabled=true;add.textContent='A ADICIONAR…';
    try{
     const res=await fetch(prefix+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:v.id,quantity:1})});
     const data=await res.json();if(!res.ok)throw Error(data.description||data.message||'Erro ao adicionar');
     document.dispatchEvent(new Event('cart:refresh'));add.textContent='ADICIONADO ✓';
    }catch(e){add.textContent='TENTAR NOVAMENTE';add.textContent='NÃO FOI POSSÍVEL ADICIONAR'}
    finally{add.disabled=false;setTimeout(()=>{if(add.isConnected)add.textContent='ADICIONAR AO CARRINHO'},2300)}
   });
   card.appendChild(add);const rm=txt('button','td-favorite-card__remove','Remover dos favoritos');rm.onclick=()=>store.remove(h);card.appendChild(rm);grid.appendChild(card)
  });
  status.hidden=true;
 }
 document.addEventListener('td:favorites-updated',draw);
 draw();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();